module.exports = __webpack_public_path__ + "static/img/guide-kegel.ef797d4f.png";